import { render, staticRenderFns } from "./TrainingAsignmentCard.vue?vue&type=template&id=1e5b34e2&scoped=true"
import script from "./TrainingAsignmentCard.vue?vue&type=script&lang=js"
export * from "./TrainingAsignmentCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingAsignmentCard.vue?vue&type=style&index=0&id=1e5b34e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b34e2",
  null
  
)

export default component.exports